module.exports = __webpack_public_path__ + "img/20220219_072857.1780cdb9.jpg";